<template>
  <div class="title-bar">
    <div class="title-bar__icon-wrapper">
      <QuizIcon class="title-bar__icon" />
    </div>
    <div class="title-bar__title-wrapper">
      <h4 class="title-bar__title">QUIZ: {{ title }}</h4>
    </div>
    <div class="title-bar__data-wrapper">
      <div class="title-bar__question-count">
        {{ currentPosition + 1 }}/{{ totalQuestions }}
      </div>
      <div class="title-bar__timer">
        <ClockIcon class="title-bar__timer--clock" />
        <p v-if="!finalTime" class="title-bar__timer--time">
          {{ time }}
        </p>
        <p v-else class="title-bar__timer--time-complete">{{ finalTime }}</p>
      </div>
    </div>
    <div class="title-bar__close-modal">
      <p class="title-bar__close-text">Exit Quiz</p>
      <button @click="$emit('closeModal')" class="title-bar__close-modal-btn">
        <CloseIcon class="title-bar__close-icon" />
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import QuizIcon from '@/assets/icons/course/quiz_icon.svg'
import CloseIcon from '@/assets/icons/navigation/close_icon.svg'
import ClockIcon from '@/assets/icons/clock_icon.svg'

export default {
  name: 'TitleBar',
  components: {
    QuizIcon: { ...QuizIcon, name: 'QuizIcon' },
    CloseIcon: { ...CloseIcon, name: 'CloseIcon' },
    ClockIcon: { ...ClockIcon, name: 'ClockIcon' },
  },
  data() {
    return {
      startTime: moment.now(),
      currentTime: moment.now(),
      interval: null,
      finalTime: '',
    }
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    totalQuestions: {
      type: Number,
      required: true,
    },
    currentPosition: {
      type: Number,
      required: true,
    },
    isQuizComplete: {
      type: Boolean,
      required: true,
    },
    hasStarted: {
      type: Boolean,
      required: false,
      default() {
        return true
      },
    },
  },
  watch: {
    isQuizComplete(isQuizComplete) {
      if (isQuizComplete) {
        this.finalTime = this.time
        this.$emit('finalTime', this.finalTime)
      }
      if (!isQuizComplete) {
        this.startTime = moment.now()
        this.currentTime = moment.now()
        this.interval = setInterval(this.updateCurrentTime, 1000)
        this.finalTime = ''
      }
    },
  },
  computed: {
    time() {
      return moment(this.milliseconds).format('mm:ss')
    },
    milliseconds() {
      return this.currentTime - this.startTime
    },
  },
  methods: {
    updateCurrentTime() {
      this.currentTime = moment.now()
    },
  },
  created() {
    if (this.hasStarted) {
      this.interval = setInterval(this.updateCurrentTime, 1000)
    }
  },
}
</script>

<style lang="scss" scoped>
.title-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 30px 20px 50px 20px;
  max-width: 2400px;
  z-index: 204;
  background: var(--white);
  &__icon-wrapper {
    width: 50px;
    margin: 5px 0 0 0;
  }
  &__icon {
    width: 40px;
  }
  &__title-wrapper {
    width: 50%;
    @include desktop {
      width: 65%;
    }
  }
  &__title {
    margin: 0;
    padding: 0;
    font-size: 1rem;
    line-height: 1rem;
    display: none;
    @include mobile {
      display: block;
    }
    @include desktop {
      font-size: 22px;
      line-height: 2.5rem;
    }
  }
  &__data-wrapper {
    display: flex;
  }
  &__question-count {
    display: flex;
    align-items: center;
    margin: 0 5px 0 0;
    font-size: 1rem;
    padding: 0 30px;
    background: var(--border-gray);
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    @include desktop {
      font-size: 36px;
    }
  }
  &__timer {
    display: flex;
    align-items: center;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    padding: 0 30px;
    background: var(--border-gray);
    width: 185px;
    &--clock {
      margin: 0 5px 0 0;
      @include desktop {
        margin: 0;
        width: 35px;
      }
    }
    &--time {
      font-size: 1rem;
      margin: 0;
      padding: 0;
      @include desktop {
        font-size: 36px;
      }
    }
    &--time-complete {
      color: var(--green);
      font-size: 1rem;
      margin: 0;
      padding: 0;
      @include desktop {
        font-size: 36px;
      }
    }
  }
  &__close-modal {
    display: flex;
    align-items: center;
    margin: 0 0 0 auto;
  }
  &__close-text {
    display: none;
    color: var(--lighter-gray);
    font-size: 16px;
    margin: 0;
    @include desktop {
      display: block;
    }
  }
  &__close-modal-btn {
    background: none;
    border: none;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
  &__close-icon {
    margin: 8px 0 0 0;
    color: var(--black);
  }
}
</style>
